export default __webpack_public_path__ + "static/media/NeilForan.b9da4d39.jpg";